module.exports = __webpack_public_path__ + "static/media/M42ws.9046884c.pdf";